<div class="cont" *ngIf="theme === 'theme1'">
    <ul class="tabs switches" [class.theme1]="theme === 'theme1'">
        <li class="tab switch" *ngFor="let panel of panels; let i = index" [class.step]="panel.step"
            [class.disabled]="panel.disabled" (click)="activateTab(panel)" [class.active]="panel.active"
            [class.on]="theme === 'theme2' && activePanel>=i">
            <ng-container *ngIf="counterActive">
                {{i+1}}
            </ng-container>
            <i class="material-icons left" *ngIf="panel.icon">
                {{panel.icon}}
            </i>
            {{ panel.label}}
            <span class="deco"></span>
        </li>
    </ul>
</div>
<div class="ul-steps" *ngIf="theme === 'theme2'">
    <ul class="tabs switches2 theme2" [class.ul-width]="panels?.length == 1">
        <li class="tab switch" *ngFor="let panel of panels; let i = index" [class.step]="panel.step"
            [class.disabled]="panel.disabled" (click)="activateTab(panel)" [class.active]="panel.active">
            <!-- <ng-container *ngIf="counterActive">
                            {{i+1}}
                        </ng-container> -->
            <i class="material-icons left" *ngIf="panel.icon">
                {{panel.icon}}
            </i>
            <span class="pointer cursor-pointer" [class.on]="theme === 'theme2' && activePanel>=i">
                <p> {{i+1}} </p>
            </span>
            <span class="ln" [class.onLn]="theme === 'theme2' && activePanel>=(i+1)"></span>
            <!-- <span class="deco"></span> -->
            <!-- <ng-container *ngTemplateOutlet="panel.label2"></ng-container>
            <ng-container *ngIf="panel.label">{{panel.label}}</ng-container> -->
            <div class="ti">
                <span class="title cursor-pointer" *ngIf="activePanel==i" [class.onTitle]="theme === 'theme2' && activePanel>=i">
                    <ng-container  *ngTemplateOutlet="panel.label2"></ng-container>
                    <ng-container *ngIf="panel.label">- {{panel.label}}</ng-container>
                </span>
            </div>
        </li>
    </ul>
   
</div>
<div class="panels-wrapper">
    <div class="panel-container">
        <div *ngFor="let panel of panels" [attr.id]="panel.id" class="panel" [class.autoheight]="autoHeight"
            [class.panel-active]="panel.active">
            <ng-container *ngIf="panel.active">
                <div class="template-container" *ngTemplateOutlet="panel.content"></div>
            </ng-container>
        </div>
    </div>
</div>
<div class="next" *ngIf="theme === 'theme2'">
    <button class="btn" (click)="next()" *ngIf="this.activePanel<this.totalPanel-1">
        Suivant
    </button>
</div>